module.exports = require('../dist/src/runtime/http');
